let cartEntryPromise = null;

function loadCartEntry() {
  if (!cartEntryPromise) {
    cartEntryPromise = import("./cart-entry.js");
  }
  return cartEntryPromise;
}

document.addEventListener("click", async (e) => {
  const link = e.target.closest("[data-cart-link]");
  if (!link) return;

  e.preventDefault();

  const { openCartDrawer } = await loadCartEntry();
  openCartDrawer();
});
